import { render } from "./RepairTile.vue?vue&type=template&id=ead77d64&scoped=true&ts=true&lang=pug"
import script from "./RepairTile.vue?vue&type=script&lang=ts"
export * from "./RepairTile.vue?vue&type=script&lang=ts"

import "./RepairTile.vue?vue&type=style&index=0&id=ead77d64&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ead77d64"]])

export default __exports__